/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export const $Pm2IndexResponse = {
    properties: {
        hostname: {
            type: 'string',
            isRequired: true,
        },
        uid: {
            type: 'string',
            isRequired: true,
        },
        username: {
            type: 'string',
            isRequired: true,
        },
        pmId: {
            type: 'number',
            isRequired: true,
        },
        pid: {
            properties: {
            },
            isRequired: true,
        },
        processName: {
            type: 'string',
            isRequired: true,
        },
        status: {
            type: 'string',
            isRequired: true,
        },
        cron: {
            type: 'string',
            isRequired: true,
        },
        killTimeout: {
            properties: {
            },
            isRequired: true,
        },
        started: {
            properties: {
            },
            isRequired: true,
        },
        startedTime: {
            properties: {
            },
            isRequired: true,
        },
        restartCount: {
            properties: {
            },
            isRequired: true,
        },
        memoryUsage: {
            properties: {
            },
            isRequired: true,
        },
        memoryUsageBytes: {
            properties: {
            },
            isRequired: true,
        },
        cpuPercent: {
            properties: {
            },
            isRequired: true,
        },
        rtxEnvVars: {
            properties: {
            },
            isRequired: true,
        },
    },
};